import { graphql } from '../../graphql/graphql';
import { weblinkFragment } from '../../graphql/weblinkFragment';
import { seoFooterFragment } from './fragments/seoFooterFragment';
import { sortOptionsFragment } from '../../graphql/sortOptionsFragment';
import { searchResultsFragment } from './fragments/searchResultsFragment';
import { buttonFragment } from '../../graphql/buttonFragment';
import { paginationFragment } from '../../graphql/paginationFragment';
import { textFragment } from '../../graphql/textFragment';

export const SearchLandingPageBySlug_SearchLandingPage = graphql(
  `
    fragment SearchLandingPageBySlug_SearchLandingPage on SearchLandingPage {
      searchQuery
      helmet {
        canonical
        helmetTitle: title
        description
        siteName
        robots
      }
      breadCrumbs {
        ...WebLink
      }
      header {
        mapViewButtonV2 {
          ... on WebLink {
            ...WebLink
          }
        }
        mapSplitViewButton {
          ... on WebLink {
            ...WebLink
          }
        }
        title {
          overlineV2
          title
          subtitleV2
        }
        sortOptions {
          ...SortOptionsFragment
        }
      }
      contentV2 {
        mapViewButtonV2 {
          ... on WebLink {
            ...WebLink
          }
        }
        mapSplitViewButton {
          ... on WebLink {
            ...WebLink
          }
        }
        exactResults {
          ...SearchResultsFragment
        }
        surroundingResults {
          ...SearchResultsFragment
        }
        resultsBannerV2 {
          part1
          part2
          part3
          action {
            ... on Button {
              ...Button
            }
          }
        }
        leadingResultsBanner {
          part1
          part2
        }
        suburbInsightsBanner @include(if: $toggleSuburbCTA) {
          title
          insights {
            ...Text
          }
          cta {
            ...WebLink
          }
          disclaimerText
        }
        pagination {
          ...Pagination
        }
      }
      vgDisclaimerHtml
      showDataDisclaimer
      footer {
        ...SeoFooterFragment
      }
      tracking {
        useUserContext
        pageData {
          pageType
          siteSection
          site
        }
        searchResultsContext {
          schema
          data {
            results_total
            page_number
            results_count
          }
        }
        searchParametersContextV3 {
          schema
          data {
            locations_requested
            include_surrounding_suburbs
            property_status
            property_types
            bedrooms_min
            bathrooms_min
            land_min
            indoor_features
            outdoor_features
            eco_friendly_features
            car_spaces_min
            keywords
            exclude_deposit_taken
            exclude_properties_without_image
            exclude_under_contract
            sort_by
            price_min
            price_max
          }
        }
      }
    }
  `,
  [
    seoFooterFragment,
    weblinkFragment,
    sortOptionsFragment,
    searchResultsFragment,
    buttonFragment,
    paginationFragment,
    textFragment,
  ],
);

export const ErrorPage = graphql(`
  fragment ErrorPage on ErrorPage {
    errorCode
  }
`);

export const SearchLandingPageBySlugQuery = graphql(
  `
    query SearchLandingPageBySlug(
      $slug: String!
      $imageFormatWebp: ImageFormat!
      $showPrice: Boolean = false
      $toggleSuburbCTA: Boolean = false
    ) {
      searchLandingPageBySlug(slug: $slug) {
        ... on SearchLandingPage {
          ...SearchLandingPageBySlug_SearchLandingPage
        }
        ... on ErrorPage {
          ...ErrorPage
        }
      }
    }
  `,
  [SearchLandingPageBySlug_SearchLandingPage, ErrorPage],
);
